import { Menu } from '@base-ui-components/react/menu'
import { cn } from '../../utils/cn'

export function MenuPositioner({ className, keepMounted, ...props }: MenuPositioner.Props) {
  return (
    <Menu.Portal keepMounted={keepMounted}>
      <Menu.Positioner className={cn('outline-none', className)} {...props} />
    </Menu.Portal>
  )
}

export namespace MenuPositioner {
  export interface Props extends Menu.Positioner.Props {
    keepMounted?: boolean
  }
}
